/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.sherpa.customers.orders.detail.controllers', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.service.order',
  'acme.common.factory.notice',
  'acme.view.application.orders.refund.confirmModal.controllers',
  'acme.common.service.userPreferences'
])

.controller('SherpaCustomersOrdersDetailController', ['$scope', '$state', '$uibModal', '$filter', '$timeout', 'ApiService', 'HelpersService', 'CalendarService', 'OrderService', 'NoticeFactory', 'UserPreferencesService', function($scope, $state, $uibModal, $filter, $timeout, ApiService, HelpersService, CalendarService, OrderService, NoticeFactory, UserPreferencesService) {

    $scope.sherpaCustomersOrdersDetail = {
      order: '',
      id: '',
      email: '',
      isProcessing: false,

      refundModal: {},

      orderDetails: {
        columns: 1,
        data: 'sherpaCustomersOrdersDetail.order',
        include: [
          'orderNumber',
          'checkInStatus',
          'createdOn',
          'legacy'
        ],
        mappings: {
          'legacy': 'Order Type'
        },
        filters: {
          'createdOn': function(item) {
            return $filter('date')(item, UserPreferencesService.getDateFormat('standardDateTime', 'dateFormat')) + ' at ' + $filter('date')(item, UserPreferencesService.getDateFormat('standardTime', 'hourFormat'));
          }
        }
      },

      orderContactDetails: {
        columns: 1,
        data: 'sherpaCustomersOrdersDetail.order',
        include: [
          'contactFirstName',
          'contactLastName',
          'email',
          'phoneNumber'
        ]
      },

      billingDetails: {
        columns: 1,
        data: 'sherpaCustomersOrdersDetail.order',
        include: [
          'billingFirstName',
          'billingLastName',
          'billingEmail',
          'billingPhoneNumber'
        ]
      },

      orderNotes: {
        columns: 1,
        data: 'sherpaCustomersOrdersDetail.order',
        include: [
          'notes'
        ],
        mappings: {
          'notes': 'Order Notes'
        }
      },

      getItemType: OrderService.getItemType,
      notice: new NoticeFactory(),
      dateFormat: UserPreferencesService.getDateFormat('shortDate', 'dateFormat'),
      hourFormat: UserPreferencesService.getDateFormat('standardTime', 'hourFormat'),

      init : function() {
        $scope.$emit('Application::contentTitleChange', {
          title: 'Order',
          buttonLeft: {
            label: 'Cancel',
            action: function() {
              window.history.go(-1);
            }
          },
          buttonRight: {
            label: 'Refund',
            action: function() {
              $scope.sherpaCustomersOrdersDetail.complete();
            }
          }
        });
        if ($state.params.hasOwnProperty('id')) {
          $scope.sherpaCustomersOrdersDetail.id = $state.params.id;
          $scope.sherpaCustomersOrdersDetail.getOrder();
        }
        $scope.$on('ResendEmail::Send', this.onResendEmailSend);
        $scope.$on('UserPreferencesService:onDateFormatLoad', this.onDateFormatLoad);
      },
      getOrder: function() {
        ApiService.customerService.getOrder($scope.sherpaCustomersOrdersDetail.id).then($scope.sherpaCustomersOrdersDetail.success.getOrder, $scope.sherpaCustomersOrdersDetail.error.getOrder);
      },

      complete: function() {
        var self = $scope.sherpaCustomersOrdersDetail;

        this.notice.hideSuccessMessages();
        this.notice.hideErrorMessages();

        if (this.order.refundTotalQuantity > 0) {
          self.refundModal = $uibModal.open({
            templateUrl: 'views/application/views/orders/refund/modals/confirm.tpl.html',
            controller: 'OrdersRefundConfirmModalController',
            resolve: {
              currentRefund: function () {
                return {
                  total: self.order.refundTotalAmount,
                  quantity: self.order.refundTotalQuantity
                };
              }
            }
          });

          // Invoked when modal completes with close(params)
          self.refundModal.result.then(function () {
            self.checkout();
          }, function () {
            // Do nothing
          });
        }else{
          this.notice.showErrorMessages([{ message: 'You must add tickets to your refund.'}]);
        }
      },


      checkout: function() {

        var currentEvent,
            orderItemCount,
            currentOrderItem,
            self = $scope.sherpaCustomersOrdersDetail,
            order = self.order,
            eventCount = order.events.length,
            orderIndex = 0,
            orderItemIndex = 0,
            refundObject = {
              orderId: order.id,
              incidentReasonCode: 'CANCELLED_EVENT',
              refundItems: []
            };

        self.isProcessing = true;

        for (orderIndex = 0; orderIndex < eventCount; orderIndex++) {
          currentEvent = order.events[orderIndex];
          orderItemCount = currentEvent.orderItems.length;

          for (orderItemIndex = 0; orderItemIndex < orderItemCount; orderItemIndex++) {
            currentOrderItem = currentEvent.orderItems[orderItemIndex];
            if (currentOrderItem.quantity !== currentOrderItem.updatedQuantity) {
              refundObject.refundItems.push({
                  orderItemId: parseInt(currentOrderItem.itemId, 10),
                  incidentReasonCode: 'CANCELLED_EVENT',
                  quantity: currentOrderItem.quantity -  currentOrderItem.updatedQuantity
                }
              );
            }
          }
        }
        console.log('refundObject', refundObject);
        ApiService.refunds.refund(refundObject).then(self.success.checkout, self.error.checkout);
      },
      sendEmail: function(email) {
        console.log('SherpaCustomersOrdersDetailController::sendEmail', email);
        ApiService.orders.email({
          id: this.order.orderNumber,
          email: email
        }).then(this.success.sendEmail, this.error.sendEmail);
      },
      cancel: function() {
        $location.href='/app/sherpa/customers';

      },
      updateQuantity: function() {
        var orderItemCount,
            currentEvent,
            currentOrderItem,
            orderIndex,
            self = $scope.sherpaCustomersOrdersDetail,
            order = self.order,
            eventCount = order.events.length,
            orderItemIndex = 0,
            currentTotal = 0,
            currentSubTotal = 0,
            currentRefundSubTotal = 0,
            currentRefundQuantity = 0;

        for (orderIndex = 0; orderIndex < eventCount; orderIndex++) {
          currentEvent = order.events[orderIndex];
          orderItemCount = currentEvent.orderItems.length;
          currentSubTotal = 0;

          for (orderItemIndex = 0; orderItemIndex < orderItemCount; orderItemIndex++) {
            currentOrderItem = currentEvent.orderItems[orderItemIndex];
            console.log('currentOrderItem', currentOrderItem);
            if (currentOrderItem.refundQuantity > currentOrderItem.quantity) {
              currentOrderItem.refundQuantity = currentOrderItem.quantity;
            }
            if (currentOrderItem.disountedUnitPrice) {
              currentSubTotal = currentSubTotal + currentOrderItem.refundQuantity * currentOrderItem.discountedUnitPrice;
            } else {
              currentSubTotal = currentSubTotal + currentOrderItem.refundQuantity * currentOrderItem.unitPrice;
            }
            currentOrderItem.updatedQuantity = currentOrderItem.quantity - currentOrderItem.refundQuantity;
            currentRefundQuantity += parseInt(currentOrderItem.refundQuantity, 10);
          }

          currentEvent.updatedTotalAmount = HelpersService.integerToCurrencyFloat(currentSubTotal);
          currentRefundSubTotal += currentSubTotal;
        }

        console.log('SherpaCustomersOrdersDetailController::updateQuantity', HelpersService.currencyFloatToInteger(order.initialTotalAmount), currentRefundSubTotal);
        order.updatedTotalAmount = HelpersService.integerToCurrencyFloat(HelpersService.currencyFloatToInteger(order.initialTotalAmount) - currentRefundSubTotal);
        order.refundTotalAmount = HelpersService.integerToCurrencyFloat(currentRefundSubTotal);
        order.refundTotalQuantity = parseInt(currentRefundQuantity, 10);

      },
      enabled: function(itemId) {
        var orderIndex,
            currentEvent,
            orderItemCount,
            currentOrderItem,
            self = $scope.sherpaCustomersOrdersDetail,
            order = self.order,
            eventCount = order.events.length,
            orderItemIndex = 0;

        for (orderIndex = 0; orderIndex < eventCount; orderIndex++) {
          currentEvent = order.events[orderIndex];
          orderItemCount = currentEvent.orderItems.length;

          for (orderItemIndex = 0; orderItemIndex < orderItemCount; orderItemIndex++) {
            currentOrderItem = currentEvent.orderItems[orderItemIndex];
            if (currentOrderItem.itemId == itemId) {
              return currentOrderItem.quantity > 0;
            }

          }
        }
        return true;
      },
      onResendEmailSend: function(e, data) {
        $scope.sherpaCustomersOrdersDetail.sendEmail(data.email);
      },

      process: function(order) {

        var i, ii,
            j, jj;

        order.refundTotalAmount = 0;
        order.refundTotalQuantity = 0;

        for (i=0,ii=order.events.length;i<ii;i++) {
          if (order.events[i].eventStartTime) {
            order.events[i].startDate = $filter('date')(CalendarService.parseDate(order.events[i].eventStartTime), this.dateFormat);
            order.events[i].startHour = $filter('date')(CalendarService.parseDate(order.events[i].eventStartTime), this.hourFormat);
          }else{
            order.events[i].startDate = 'Date N/A';
            order.events[i].startHour = 'Time N/A';
          }
          for (j=0,jj=order.events[i].orderItems.length;j<jj;j++) {
            order.events[i].orderItems[j].refundQuantity = 0;
          }
        }

        return order;

      },

      success : {
        getOrder: function(response) {
          var self = $scope.sherpaCustomersOrdersDetail;
          console.log('getOrder', response);
          self.order = self.process(response.data.payload);
          self.email = self.order.email;
        },
        checkout: function(response) {
          var self = $scope.sherpaCustomersOrdersDetail;

          self.isProcessing = false;

          $timeout(function() {
            $state.go('application.sherpa.customers.list');
          }, 100);
        },
        sendEmail: function(response) {

        }
      },
      error : {
        getOrder : function(response) {

        },
        checkout : function(response) {

        },
        sendEmail: function(response) {

        }
      },
      onDateFormatLoad: function (e, data) {
        $scope.sherpaCustomersOrdersDetail.dateFormat = UserPreferencesService.getDateFormat('shortDate', 'dateFormat');
        $scope.sherpaCustomersOrdersDetail.hourFormat = UserPreferencesService.getHourFormat('standardTime', 'hourFormat');
      }
    };

    $scope.sherpaCustomersOrdersDetail.init();

}]);